import React from "react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section
      className="relative overflow-hidden min-h-[400px] sm:min-h-[400px] md:min-h-[400px] flex items-center"
      style={{
        background:
          "radial-gradient(51.47% 93.67% at 92.92% 27.08%, #384991 0%, #161837 72.6%)",
      }}
    >
      <div className="relative z-10 max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-20 items-center">
          {/* Left Side - Text Content */}
          <div className="text-left animate-fade-in-up">
            <h1 className="text-4xl sm:text-4xl mt-16 md:text-[72px] lg:text-6xl font-bold mb-6 text-[#FBBF24] leading-tight">
              Trade Crypto.
            </h1>

            <p className="md:text-[38px] sm:text-lg text-xl font-[700] lg:text-[38px] mb-8 sm:mb-10 text-white max-w-xl leading-relaxed">
              Fast, Secure & Borderless
            </p>

            <p className="text-base sm:text-lg md:text-[20px] font-[500] lg:text-xl mb-8 sm:mb-10 text-white max-w-xl leading-relaxed">
              Buy, sell, and trade digital assets instantly with P2P1 Digital Asset Marketplace —
              built for speed, reliability, and global accessibility
            </p>

            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
              <Link
                to="/markets"
                className="group border-2 !rounded-full border-[#FBBF24] bg-transparent text-white px-6 py-3 sm:px-8 sm:py-4 rounded-lg font-semibold text-sm sm:text-base hover:bg-[#FBBF24]/10 transition-all duration-300 flex items-center justify-center"
              >
                Explore Platform
              </Link>
              <Link
                to="/swap"
                className="group !rounded-full bg-[#FBBF24] text-[#161837] px-6 py-3 sm:px-8 sm:py-4 rounded-lg font-semibold text-sm sm:text-base hover:bg-[#FCD34D] transition-all duration-300 flex items-center justify-center shadow-lg hover:shadow-xl"
              >
                Start Trading
              </Link>
            </div>
          </div>

          {/* Right Side - Hero Image */}
          <div className="relative flex items-center justify-center lg:justify-end animate-fade-in-up animation-delay-400">
            <div className="w-full max-w-lg lg:max-w-xl animate-float">
              <img
                src="/hero.svg"
                alt="Crypto Trading Platform"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS for animations */}
      <style>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
        }
        
        .animation-delay-400 {
          animation-delay: 400ms;
        }
        
        .animate-float {
          animation: float 3s ease-in-out infinite;
          animation-delay: 0.8s;
        }
      `}</style>
    </section>
  );
};

export default Hero;
